export const M2_UNIT_14 = {
  id: "m2-u14",
  title: "Unit 14: Food & Drink",
  topic: "Food Vocabulary & Countability",
  iconType: "shopping", // Usamos 'shopping' (bolsa) para comida
  grammarImage: "/m2-u14-grammar.jpg", // Recuerda subir esta imagen a public
  grammarText: "Aprendemos vocabulario de comida y la diferencia entre contables (an apple) e incontables (rice, water).",
  sets: [
    {
      id: "u30-set1",
      title: "Set 1: Food Categories - Basic",
      questions: [
        { type: "mc", q: "Chicken, beef = ___", options: ["meat", "fish", "fruit"], a: "meat" },
        { type: "mc", q: "Apple, banana = ___", options: ["fruit", "vegetables", "bread"], a: "fruit" },
        { type: "blank", q: "Carrots, potatoes = ___ (vegetables).", options: ["vegetables"], a: "vegetables" },
        { type: "mc", q: "Salmon, tuna = ___", options: ["fish", "seafood", "meat"], a: "fish" },
        { type: "blank", q: "Shrimp, lobster = ___ (seafood).", options: ["seafood"], a: "seafood" },
        { type: "order", q: "Ordena: pasta", words: ["pasta"], a: "pasta" },
        { type: "mc", q: "'Bread' = bakery food. True?", options: ["True", "False"], a: "True" },
        { type: "mc", q: "Rice, noodles = ___", options: ["pasta", "meat", "fruit"], a: "pasta" },
        { type: "blank", q: "Lettuce, tomatoes = ___ (vegetables).", options: ["vegetables"], a: "vegetables" },
        { type: "order", q: "Ordena: seafood", words: ["seafood"], a: "seafood" }
      ]
    },
    {
      id: "u30-set2",
      title: "Set 2: Drinks & Meals",
      questions: [
        { type: "mc", q: "Morning meal = ___", options: ["breakfast", "lunch", "dinner"], a: "breakfast" },
        { type: "mc", q: "Coffee, tea, juice = ___", options: ["drinks", "food", "meat"], a: "drinks" },
        { type: "blank", q: "Afternoon meal = ___ (lunch).", options: ["lunch"], a: "lunch" },
        { type: "mc", q: "Evening meal = ___", options: ["dinner", "breakfast", "fruit"], a: "dinner" },
        { type: "blank", q: "Water, milk = ___ (drinks).", options: ["drinks"], a: "drinks" },
        { type: "order", q: "Ordena: breakfast lunch dinner", words: ["breakfast,", "lunch,", "dinner"], a: "breakfast, lunch, dinner" },
        { type: "mc", q: "'Juice' = drink. True?", options: ["True", "False"], a: "True" },
        { type: "mc", q: "Pasta = Italian food.", options: ["True", "False"], a: "True" },
        { type: "blank", q: "Orange juice = ___ (drink).", options: ["drink"], a: "drink" },
        { type: "order", q: "Ordena: meat fish fruit", words: ["meat,", "fish,", "fruit"], a: "meat, fish, fruit" }
      ]
    },
    {
      id: "u30-set3",
      title: "Set 3: Food Containers",
      questions: [
        { type: "mc", q: "Liquid in: bottle, can, ___", options: ["carton", "bag", "slice"], a: "carton" },
        { type: "mc", q: "Bread: loaf, slice, ___", options: ["bag", "jar", "can"], a: "bag" },
        { type: "blank", q: "Jam: ___ (jar).", options: ["jar"], a: "jar" },
        { type: "mc", q: "Countable: slice, piece, bottle", options: ["True", "False"], a: "True" },
        { type: "blank", q: "Milk: ___ (carton).", options: ["carton"], a: "carton" },
        { type: "order", q: "Ordena: loaf of bread", words: ["loaf", "of", "bread"], a: "loaf of bread" },
        { type: "mc", q: "Sugar: bag, packet. True?", options: ["True", "False"], a: "True" },
        { type: "mc", q: "Can of soda. Correct?", options: ["True", "False"], a: "True" },
        { type: "blank", q: "Butter: ___ of butter (pack).", options: ["pack"], a: "pack" },
        { type: "order", q: "Ordena: bottle of water", words: ["bottle", "of", "water"], a: "bottle of water" }
      ]
    },
    {
      id: "u30-set4",
      title: "Set 4: Countable vs Uncountable",
      questions: [
        { type: "mc", q: "One apple. Two ___ (apples).", options: ["apples", "apple"], a: "apples" },
        { type: "mc", q: "Much water. Many ___ (bottles).", options: ["bottles", "water"], a: "bottles" },
        { type: "blank", q: "Sugar: can't count = ___ (uncountable).", options: ["uncountable"], a: "uncountable" },
        { type: "mc", "q": "Slices of bread = countable.", options: ["True", "False"], a: "True" },
        { type: "blank", q: "Rice: can't say 'one rice' = ___ (uncountable).", options: ["uncountable"], a: "uncountable" },
        { type: "order", q: "Ordena: countable foods", words: ["apple,", "slice,", "bottle"], a: "apple, slice, bottle" },
        { type: "mc", q: "Milk: uncountable, carton: countable. True?", options: ["True", "False"], a: "True" },
        { type: "mc", "q": "Two breads? Wrong = True.", options: ["True", "False"], a: "True" },
        { type: "blank", q: "Pasta: uncountable, but ___ of pasta (pack).", options: ["pack"], a: "pack" },
        { type: "order", q: "Ordena: uncountable foods", words: ["sugar,", "rice,", "water"], a: "sugar, rice, water" }
      ]
    },
    {
      id: "u30-set5",
      title: "Set 5: Ingredients & Quantities",
      questions: [
        { type: "mc", q: "Salt, pepper, sugar = ___", options: ["ingredients", "drinks", "meals"], a: "ingredients" },
        { type: "mc", q: "1 cup, 2 spoons = ___", options: ["quantities", "containers", "foods"], a: "quantities" },
        { type: "blank", q: "Flour, eggs, butter = ___ (ingredients).", options: ["ingredients"], a: "ingredients" },
        { type: "mc", q: "Liter, gram, kilogram = measures.", options: ["True", "False"], a: "True" },
        { type: "blank", q: "Recipe needs 2 ___ sugar. (cups)", options: ["cups"], a: "cups" },
        { type: "order", q: "Ordena: two teaspoons salt", words: ["two", "teaspoons", "of", "salt"], a: "two teaspoons of salt" },
        { type: "mc", q: "Oil, vinegar = ingredients. True?", options: ["True", "False"], a: "True" },
        { type: "mc", "q": "Half liter milk. Correct?", options: ["True", "False"], a: "True" },
        { type: "blank", q: "500 grams ___ (flour).", options: ["flour"], a: "flour" },
        { type: "order", q: "Ordena: one liter water", words: ["one", "liter", "of", "water"], a: "one liter of water" }
      ]
    },
    {
      id: "u30-set6",
      title: "Set 6: US/UK Food Vocabulary",
      questions: [
        { type: "mc", q: "US: cookies = UK: ___", options: ["biscuits", "chips", "crisps"], a: "biscuits" },
        { type: "mc", q: "US: fries = UK: ___", options: ["chips", "crisps", "biscuits"], a: "chips" },
        { type: "blank", q: "US: chips = UK: ___ (crisps).", options: ["crisps"], a: "crisps" },
        { type: "mc", "q": "US: eggplant = UK: ___", options: ["aubergine", "zucchini", "cookie"], a: "aubergine" },
        { type: "blank", "q": "US: zucchini = UK: ___ (courgette).", options: ["courgette"], a: "courgette" },
        { type: "order", q: "Ordena: cookies / biscuits", words: ["cookies", "(US)", "/biscuits", "(UK)"], a: "cookies (US) /biscuits (UK)" },
        { type: "mc", "q": "US: jelly = UK: jam. True?", options: ["True", "False"], a: "True" },
        { type: "mc", "q": "US: candy = UK: sweets.", options: ["True", "False"], a: "True" },
        { type: "blank", "q": "US: bell pepper = UK: ___ pepper (capsicum).", options: ["capsicum"], a: "capsicum" },
        { type: "order", q: "Ordena: fries / chips", words: ["fries", "(US)", "/chips", "(UK)"], a: "fries (US) /chips (UK)" }
      ]
    },
    {
      id: "u30-set7",
      title: "Set 7: Categorization Game",
      questions: [
        { type: "mc", "q": "MEAT: chicken, beef, ___", options: ["pork", "apple"], a: "pork" },
        { type: "blank", "q": "FRUIT: apple, banana, ___ (orange).", options: ["orange"], a: "orange" },
        { type: "mc", "q": "VEGETABLES: carrot, potato, ___", options: ["lettuce", "fish"], a: "lettuce" },
        { type: "mc", "q": "FISH: salmon, tuna, ___", options: ["cod", "bread"], a: "cod" },
        { type: "blank", "q": "SEAFOOD: shrimp, lobster, ___ (crab).", options: ["crab"], a: "crab" },
        { type: "order", q: "Categoría: DRINKS → water, juice, ___", words: ["milk"], a: "milk" },
        { type: "mc", "q": "MEALS: breakfast, lunch, dinner. True?", options: ["True", "False"], a: "True" },
        { type: "mc", "q": "CONTAINERS: bottle, jar, carton.", options: ["True", "False"], a: "True" },
        { type: "blank", "q": "PASTA: spaghetti, noodles, ___ (macaroni).", options: ["macaroni"], a: "macaroni" },
        { type: "order", q: "INGREDIENTS: salt, flour, ___", words: ["sugar"], a: "sugar" }
      ]
    },
    {
      id: "u30-set8",
      title: "Set 8: Shopping List Practice",
      questions: [
        { type: "mc", "q": "2 loaves bread, 1 liter milk, 500g cheese.", options: ["True countable/uncountable", "False"], a: "True countable/uncountable" },
        { type: "blank", "q": "Buy: jar of ___ (jam).", options: ["jam"], a: "jam" },
        { type: "mc", "q": "Pack of sugar, bottle of water. Correct?", options: ["True", "False"], a: "True" },
        { type: "blank", "q": "3 ___ apples (bags).", options: ["bags"], a: "bags" },
        { type: "mc", "q": "Can of tuna, carton of juice. True?", options: ["True", "False"], a: "True" },
        { type: "order", q: "Lista: bread, milk, eggs, cheese, apples.", words: ["loaf", "of", "bread,", "liter", "of", "milk,", "eggs,", "cheese,", "apples"], a: "loaf of bread, liter of milk, eggs, cheese, apples" },
        { type: "mc", "q": "Rice: bag of rice (uncountable). True?", options: ["True", "False"], a: "True" },
        { type: "blank", "q": "500 grams ___ (flour).", options: ["flour"], a: "flour" },
        { type: "mc", "q": "Slice of bread, piece of cake. Correct?", options: ["True", "False"], a: "True" },
        { type: "order", q: "Shopping: 2 bottles soda, 1 jar honey.", words: ["two", "bottles", "of", "soda,", "one", "jar", "of", "honey"], a: "two bottles of soda, one jar of honey" }
      ]
    },
    {
      id: "u30-set9",
      title: "Set 9: Recipe Quantities (Medium-Hard)",
      questions: [
        { type: "blank", q: "Cake recipe: 2 ___ flour, 3 ___ sugar. (cups)", options: ["cups"], a: "cups" },
        { type: "mc", "q": "2 eggs, 1 teaspoon salt, 250g butter.", options: ["True quantities", "False"], a: "True quantities" },
        { type: "blank", q: "Soup: 1 liter water, 2 ___ carrots. (chopped)", options: ["chopped"], a: "chopped" },
        { type: "mc", "q": "Salad: lettuce, tomatoes, cucumber, oil + vinegar.", options: ["True ingredients", "False"], a: "True ingredients" },
        { type: "blank", q: "Pasta: 500g pasta, 1 jar ___ sauce (tomato).", options: ["tomato"], a: "tomato" },
        { type: "order", q: "Recipe: 2 cups flour, 1 cup sugar, 2 eggs.", words: ["2", "cups", "flour,", "1", "cup", "sugar,", "2", "eggs"], a: "2 cups flour, 1 cup sugar, 2 eggs" },
        { type: "mc", "q": "1 liter milk + 200g chocolate = hot chocolate. True?", options: ["True", "False"], a: "True" },
        { type: "blank", q: "Bread: 500g flour, 1 ___ yeast. (packet)", options: ["packet"], a: "packet" },
        { type: "mc", "q": "Fish + chips = UK meal. True?", options: ["True", "False"], a: "True" },
        { type: "order", q: "Full recipe: cake ingredients.", words: ["flour,", "sugar,", "eggs,", "butter,", "milk"], a: "flour, sugar, eggs, butter, milk" }
      ]
    },
    {
      id: "u30-set10",
      title: "Set 10: Full Food Vocabulary Challenge",
      questions: [
        { type: "mc", "q": "Complete categories: meat/fish/fruit/veg/seafood/pasta/drinks. All?", options: ["True"], a: "True" },
        // Convertido a MC para evitar escritura de lista larga
        { type: "mc", "q": "Containers: bottle/jar/carton/loaf/bag/pack. Examples?", options: ["water/jam/milk/bread/sugar/butter", "meat/fish/veg"], a: "water/jam/milk/bread/sugar/butter" },
        { type: "order", q: "Master shopping list: 2 loaves bread, 1L milk, 500g cheese, apples.", words: ["2", "loaves", "bread,", "1", "liter", "milk,", "500g", "cheese,", "apples"], a: "2 loaves bread, 1 liter milk, 500g cheese, apples" },
        { type: "mc", "q": "Quick: uncountable rice → bag of rice. True?", options: ["True"], a: "True" },
        // Convertido a MC para evitar escritura de dos respuestas
        { type: "mc", "q": "US fries=UK ___, US chips=UK ___ (chips/crisps).", options: ["chips / crisps", "crisps / chips"], a: "chips / crisps" },
        { type: "mc", "q": "Recipe: 2 cups flour + 3 eggs = countable quantities. True?", options: ["True"], a: "True" },
        { type: "order", q: "Challenge: full meal plan breakfast-lunch-dinner.", words: ["breakfast:", "eggs,", "bread,", "juice", "lunch:", "sandwich,", "apple", "dinner:", "fish,", "rice,", "salad"], a: "breakfast: eggs, bread, juice lunch: sandwich, apple dinner: fish, rice, salad" },
        { type: "blank", "q": "Ingredients: salt, pepper, oil, garlic, onion, tomatoes.", options: ["5"], a: "5" },
        { type: "mc", "q": "All correct: loaf bread, jar jam, carton milk. True?", options: ["True"], a: "True" },
        { type: "order", q: "Ultimate: supermarket list.", words: ["meat,", "fish,", "vegetables,", "fruit,", "bread,", "milk,", "cheese"], a: "meat, fish, vegetables, fruit, bread, milk, cheese" }
      ]
    }
  ]
};
